import { flex } from '@onbeam/business-styled-system/patterns';

export const mobileNavItemStyles = flex({
  py: '2',
  gap: '1',
  w: 'full',
  align: 'center',
  transition: 'colors',
  textStyle: 'subtitle-sm',
  rounded: 'xs',
  cursor: 'pointer',

  _hoverFocusActive: {
    color: 'mono.tertiary',
  },
});
